import * as React from 'react';
import { DropdownButton, Dropdown } from 'react-bootstrap';
import { toastr } from 'react-redux-toastr';
import { TFunction } from 'react-i18next';
import Icon from '../common/Icon';
import { IjobHour } from '../../models';

interface Iprops {
    jobHour: IjobHour;
    t: TFunction;
    onEdit: (id: string) => void;
    onDelete: (jobHour: IjobHour) => void;
}

export const HoursRowActions: React.FC<Iprops> = ({ jobHour, t, onEdit, onDelete }) => {
    const handleSelect = (eventKey: any) => {
        if (eventKey === 'edit') {
            onEdit(jobHour.id);
        } else if (eventKey === 'delete') {
            toastr.confirm(t('deleteHoursConfirmTitle'), {
                onOk: () => onDelete(jobHour),
                onCancel: () => null,
                okText: t('deleteHoursConfirmButton'),
                cancelText: t('common:cancel')
            });
        }
    };

    return (
        <div className="hours-row-actions">
            <DropdownButton
                drop="down"
                variant="default"
                title={<Icon name="ellipsis" />}
                id={`hours-row-action-${jobHour.id}`}
                onSelect={handleSelect}
            >
                <Dropdown.Item eventKey="edit">{String(t('common:edit'))}</Dropdown.Item>
                <Dropdown.Item eventKey="delete">{String(t('common:delete'))}</Dropdown.Item>
            </DropdownButton>
        </div>
    );
};
